/**
 * Console tracing for the shared WebRTC sessions and push-to-talk.
 *
 * Kept out of `webrtc-utils` so the unit tests can stub it: `import.meta` is a
 * syntax error under the CJS jest setup, and no runtime guard helps because the
 * failure happens while the file is parsed.
 */

/** Traces session and talkback state to the console. */
export const WEBRTC_TRACE_ENABLED = import.meta.env.DEV;

/**
 * Traces a WebRTC state transition. Deliberately limited to transitions and the
 * events that cause them, so the console tells the whole story of a session
 * without drowning it in per-frame noise.
 */
export const webrtcTrace = (scope: string, event: string, detail?: Record<string, unknown>) => {
	if (!WEBRTC_TRACE_ENABLED) {
		return;
	}
	// Serialised rather than passed as an object: the console collapses objects
	// past a few keys behind an ellipsis, and a trace that loses its detail the
	// moment it is copied out of the console is no use for diagnosing a fault.
	console.info(`[WebRTC ${scope}] ${event}`, detail ? safeDetail(detail) : '');
};

const safeDetail = (detail: Record<string, unknown>): string => {
	try {
		return JSON.stringify(detail);
	} catch {
		return String(detail);
	}
};
